import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n/config";
import i18n from "./i18n/config";

// Force German language on app initialization
i18n.changeLanguage('de');
if (typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', 'de');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Set default theme class on mount
if (!document.documentElement.classList.contains('dark') && !document.documentElement.classList.contains('light')) {
  document.documentElement.classList.add('dark');
}

// Register Service Worker for PWA and caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        // Silently fail - service worker is optional for functionality
        console.debug('Service Worker registration failed (non-critical):', error.message);
      });
  });
}
